import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';

const TaxCategory = () => import('@/modules/tax-category/pages/TaxCategory.vue');

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'tax-category',
                path: '/tax-category',
                component: TaxCategory,
                meta: {
                    auth: true,
                    permission: Permissions.values.taxCategoryRead,
                }
            },
        ],
    },
];
